<template>
  <div>
    <component
      :is="to ? BaseLink : $attrs.onClick ? BaseButton : 'div'"
      class="relative f-col center"
      :class="{ 'rotate-180': dir === 'up' }"
      :to
    >
      <span
        v-if="!hideLabel"
        v-style:text-size="textSize"
        class="my-4 write-vertical-left"
        :class="{ 'rotate-180': dir === 'down' }"
        :style="dir === 'down' ? 'margin-left: -0.1rem' : 'margin-right: -0.1rem'"
      >
        <slot>
          {{ $t.discoverMore }}
        </slot>
      </span>
      <span v-style:h="height" class="relative" style="width: 0.125rem">
        <span class="animation-unfold absolute inset-x-0" style="background: currentColor" />
      </span>
      <vf-icon dir="down" name="chevron" size="md" />
    </component>
  </div>
</template>

<script lang="ts" setup>
import type { Responsive } from '#types/common'
import type { SizesSubUnion } from '#types/sizes'
import { BaseButton, BaseLink } from '#components'

const { dir = 'down', size = 'md' } = defineProps<{
  /**
   * Sets the direction of the animated bar
   */
  dir?: 'up' | 'down'
  /**
   * Sets the responsive height of the animated bar
   */
  size?: SizesSubUnion<'sm' | 'md'> | Responsive<SizesSubUnion<'sm' | 'md'>>
  /**
   * Sets link target
   */
  to?: string
  /**
   * Sets label visibility
   */
  hideLabel?: boolean
}>()

const defaultSizes = {
  sm: '1.8rem',
  md: '6.25rem'
}

const defaultTextSizes = {
  sm: '0.75rem',
  md: '1rem'
}

const height = computed(() => {
  if (isObject(size)) {
    return {
      sm: defaultSizes[size.sm],
      md: defaultSizes[size.md || size.sm]
    }
  }
  return defaultSizes[size]
})

const textSize = computed(() => {
  if (isObject(size)) {
    return {
      sm: defaultTextSizes[size.sm],
      md: defaultTextSizes[size.md || size.sm]
    }
  }
  return defaultTextSizes[size]
})
</script>
